import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import {
  Button,
  FormControl,
  Panel
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Helpers
import submit from './submit';
import validate from './validate';
//Locale
import messages from '../../../locale/jsonMessages';
import { MessageSendIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className, placeholder }) => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <FormControl
        {...input}
        className={className}
        componentClass="textarea"
        placeholder={placeholder}
      >
        {children}
      </FormControl>
      {touched && error && <span className={cx(s.sendMessageErrorMessagePosition, 'errorMessagePositionRTL')}>{formatMessage(error)}</span>}
    </div>
  );
}

const SendMessage = (props) => {

  const { formatMessage } = useIntl();

  const { error, handleSubmit, submitting } = props;

  return (
    <div className={cx(cs.spaceBottom4)}>
      <form onSubmit={handleSubmit(submit)}>
        <div className={cx(s.messageMainContainer)}>
          <div className={cx(s.lsSendMessageContainer, s.rsFromMessageMarginRight, 'lsSendMessageContainerRTL', 'rsFromMessageMarginRightRLT')}>
            <div className={cx()}>
              <div className={s.textBody}>
                <Field
                  name="content"
                  className={cx(s.sendTextBox)}
                  component={renderFormControlTextArea}
                  placeholder={formatMessage(messages.writeMessage)}
                />
              </div>
            </div>
          </div>
          <div className={cx(s.rsSendMessageContainer)}>
            <Button className={cx(s.sendMessageBtnContainer)} type="submit" disabled={submitting || error}>
              <MessageSendIcon className={cx(s.sendMessageBtn, 'commonLinkColor')} />
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}


SendMessage.propTypes = {
  threadId: PropTypes.number.isRequired,
  profileId: PropTypes.number.isRequired,
  picture: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  formatMessage: PropTypes.any,
};

export default reduxForm({
  form: 'SendMessage', // a unique name for this form
  validate
})(withStyles(cs, s)(SendMessage));